import { overlay } from 'modules/overlay';
import { OVERLAY_VIEWS } from 'constants/templates';

/**
 * @type {function}
 * @desc An utility function to do [something]
 * @example
 * import { successOverlay } from 'utils/successOverlay';
 * const result = successOverlay( ...args );
 */
export const open = ( { message, config, settings } = {} ) => {
    log.debug( 'successOverlay.open()' );

    return overlay.open( {
        settings: {
            modalType: OVERLAY_VIEWS.SUCCESS_VIEW,
            showCloseButton: false,
            ...settings
        },
        config: {
            autoClose: true,
            ...config
        },
        data: {
            message
        }
    } );
};
